import { render, staticRenderFns } from "./VerProgramaPostgradoPage.vue?vue&type=template&id=1ecdd922&scoped=true&"
import script from "./VerProgramaPostgradoPage.js?vue&type=script&lang=js&"
export * from "./VerProgramaPostgradoPage.js?vue&type=script&lang=js&"
import style0 from "./VerProgramaPostgradoPage.vue?vue&type=style&index=0&id=1ecdd922&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ecdd922",
  null
  
)

export default component.exports